
import { GAME_ART, elem, styleInstaller } from "./chrome";

export const GIFTBOX_WIDTH = 50;
export const GIFTBOX_HEIGHT = 50;
export const GIFTBOX_TOOLTIP = "Gift";

export interface GiftBoxActions {
  readonly onOpenMall?: () => void;
}

const STYLE_ID = "giftbox-style";
const STYLE = `
.giftbox {
  position: fixed;
  left: 0;
  bottom: 45px;
  z-index: 40;
  width: ${GIFTBOX_WIDTH}px;
  height: ${GIFTBOX_HEIGHT}px;
  pointer-events: auto;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}
.giftbox-icon {
  position: absolute;
  left: 5px;
  top: -90px;
  width: 50px;
  height: 50px;
  background: url("${GAME_ART}/giftbox.png") center / contain no-repeat;
}
.giftbox-tooltip {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 50px;
  height: 10px;
}
`;

const installStyle = styleInstaller(STYLE_ID, STYLE);

export class GiftBox {
  readonly element: HTMLButtonElement;

  constructor(mount: HTMLElement, private readonly actions: GiftBoxActions = {}) {
    const doc = mount.ownerDocument;
    installStyle(doc);
    this.element = doc.createElement("button");
    this.element.type = "button";
    this.element.className = "giftbox";
    this.element.hidden = true;
    this.element.title = GIFTBOX_TOOLTIP;
    this.element.setAttribute("aria-label", GIFTBOX_TOOLTIP);
    const icon = elem(doc, "span", "giftbox-icon");
    const tip = elem(doc, "span", "giftbox-tooltip");
    this.element.append(icon, tip);
    this.element.addEventListener("click", () => {
      this.hide();
      this.actions.onOpenMall?.();
    });
    mount.append(this.element);
  }

  setHasGift(hasGift: boolean): void {
    this.element.hidden = !hasGift;
  }

  hide(): void {
    this.element.hidden = true;
  }

  get showing(): boolean {
    return !this.element.hidden;
  }
}
